import React, { useState, useEffect } from 'react';
import { Form, Input, message, Spin } from 'antd';

import { renderIntlLabel } from '@/utils';
import { parseFen2Currency } from '@/utils/number';
import { fetchXuanzhuBalanceByWyuId } from '@/api/payment';

import { XuanZhuProps } from './interface';
import styles from './payModal.module.scss';

const Xuanzhu: React.FC<XuanZhuProps> = (props) => {
  const { certNo, wyuid, payAmount, payModalVisible } = props;

  const [cashForm] = Form.useForm(null);
  const [balance, setBalance] = useState(null);
  const [restBalance, setRestBalance] = useState(0); // 扣款后余额
  const [queryLoading, setQueryLoading] = useState(false);

  // 根据wyuid查询选住余额信息
  const queryBalanceInfo = async (params) => {
    const { wyuid: uid } = params || {};
    setQueryLoading(true);
    try {
      const res = await fetchXuanzhuBalanceByWyuId({ wyuid: uid });

      if (res && res.status) {
        setBalance(res.data?.balance);
        setRestBalance(res.data?.balance - payAmount);
        // callback parent
        props.balanceChangeCallback({
          balance: res.data?.balance,
          wyuid: res.data?.wyuid,
        });
      } else {
        message.error(res.msg || renderIntlLabel('bill_msg_fail_query_xuanzhu_remaining_money'));
      }
      setQueryLoading(false);
    } catch (err) {
      setQueryLoading(false);
      setBalance(null);
      setRestBalance(null);
    }
  };

  // 初始化
  useEffect(() => {
    if (payModalVisible && certNo && wyuid) {
      queryBalanceInfo({ wyuid });
      cashForm.setFieldsValue({ certNo });
    }
  }, [payModalVisible, certNo, wyuid]);

  // reset states when unmounted
  useEffect(() => {
    return () => {
      setRestBalance(0);
    };
  }, []);

  return (
    <div className={styles['pay-content']}>
      <Form form={cashForm} preserve={false} className={styles['cash-form']}>
        <Form.Item label={renderIntlLabel('order_roomorder_cert_no')} name="certNo">
          <Input value={certNo} disabled />
        </Form.Item>
      </Form>
      <Spin spinning={queryLoading} wrapperClassName={styles['balance-info-loading']}>
        <ul className={styles['balance-info']} style={{ width: '100%' }}>
          <li>
            <label className="text-colon">
              {renderIntlLabel('bill_label_current_remaining_money')}
            </label>
            {parseFen2Currency(balance)}
          </li>
          <li>
            <label className="text-colon">
              {renderIntlLabel('bill_label_remianing_money_after_deduct')}
            </label>
            {balance >= 0 ? (
              <span className={restBalance < 0 ? styles['rest-balance-negative'] : ''}>
                {parseFen2Currency(restBalance)}
              </span>
            ) : (
              '-'
            )}
          </li>
        </ul>
      </Spin>
    </div>
  );
};

export default Xuanzhu;
